export const replaceInstallationName = (
  text,
  installationName = typeof window === 'undefined'
    ? undefined
    : window.globalConfig?.INSTALLATION_NAME
) => {
  if (!text) return text;
  if (!installationName) return text;

  return text
    .replace(/chatwoot inbox/gi, installationName)
    .replace(/chatwoot/gi, installationName);
};

export const replaceInstallationNameInTranslation = text =>
  replaceInstallationName(text);
